import { z } from 'zod';

/** Longueur minimale d'un mot de passe local (même règle que l'API : App\Entity\User::PASSWORD_MIN_LENGTH) */
export const PASSWORD_MIN_LENGTH = 8;

/** Nouveau mot de passe + confirmation */
export const newPasswordSchema = z
  .object({
    plainPassword: z.string().min(PASSWORD_MIN_LENGTH, `${PASSWORD_MIN_LENGTH} caractères minimum`),
    confirmation: z.string(),
  })
  .refine((data) => data.plainPassword === data.confirmation, {
    message: 'Les deux mots de passe ne correspondent pas',
    path: ['confirmation'],
  });

export type NewPasswordForm = z.infer<typeof newPasswordSchema>;
